import React, { useEffect, useRef, useState } from "react";
import { Box, Skeleton } from "@mui/material";
import { AppContext } from "../../store";
import Logo from "../../assets/images/Logo/Logo.png";


export const AppLogo = ({
  alt,
  sx,
  skeletonSx,
  skeletonVariant = "rounded",
  ...rest
}) => {
  const { appState } = React.useContext(AppContext);

  const logoSrc = appState?.isAppSettingsFetched ? (appState.appSettings.app_icon || Logo) : null;

  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    // A cached image can finish loading before React attaches onLoad, so the
    // event never fires. Check the element's own completion state instead.
    setLoaded(Boolean(imgRef.current?.complete));
  }, [logoSrc]);

  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      {!loaded && <Skeleton variant={skeletonVariant} sx={skeletonSx} />}
      {logoSrc && (
        <Box
          component="img"
          ref={imgRef}
          src={logoSrc}
          alt={alt}
          onLoad={() => setLoaded(true)}
          onError={() => setLoaded(true)}
          sx={{ display: loaded ? "block" : "none", ...sx }}
          {...rest}
        />
      )}
    </Box>
  );
};
